import React from 'react';
import './CompanyLeadership.css';

export default function CompanyLeadership() {
  return (
    <section className="company-leadership journey-shell" id="our-team" data-investor-section="our-team" aria-labelledby="company-leadership-title">
      <h2 className="journey-title" id="company-leadership-title">People behind <em>Cornucopia.</em></h2>
      <div className="company-founders">
        <h3>Leadership</h3>
        <dl>
          <div><dt>Mickey Makhija</dt><dd>Founder</dd><dd>Molecular biology and lab automation, with experience at Amgen and BioMarin.</dd></div>
          <div><dt>Ajinkya Lakade</dt><dd>CTO</dd><dd>Engineering experience at Verily.</dd></div>
        </dl>
        <p className="company-backing">Backed by Antler and Right Side Capital.</p>
      </div>
      <div>
        <h3>Our advisors</h3>
        <dl className="company-advisors">
          <div><dt>Brandon Ason</dt><dd>Big Pharma executive.</dd></div>
          <div><dt>Tom Gilman</dt><dd>Founder and former CEO of Biosero.</dd></div>
          <div><dt>Erin Whalen</dt><dd>Big Pharma executive.</dd></div>
        </dl>
      </div>
    </section>
  );
}
